import styled from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

export const Container = styled.div`
  padding: 0 0 1.5rem;
  display: block;

  label {
    ${theme.typography.labelRegular}
  }

  svg {
    vertical-align: middle;
    padding-left: 0.4rem;
  }
`;

export const TooltipWrapper = styled.div`
  text-align: left !important;
  font-size: 0.9rem;
  padding: 0.2rem;
`;

export const Description = styled.div`
  padding-left: 2.25rem;
  margin-top: 0.25rem;
  color: ${theme.color.text.secondary};
  ${theme.typography.bodyRegular}

  @media (min-width: ${breakpoints.md}) {
    max-width: 27rem;
  }

  a {
    text-decoration: underline;
  }
`;
